import React, { PureComponent } from 'react';
import {
  Row,
  Col,
  Button,
  Spinner,
} from 'reactstrap';
import InformationOutlineIcon from 'mdi-react/InformationOutlineIcon';
import firebaseAuth from '../../../../utils/firebase';
import callDb from '../../../../utils/server';

// const goKyc = () => {
//   console.log('must go to KYC method');
// };

class IdentityCheck extends PureComponent {
  constructor() {
    super();
    this.state = {
      isLoading: false,
    };
  }

  loginFC = () => {
    this.setState({ isLoading: true });
    callDb({}, 'users/verify_fc').then((result) => {
      const { data } = result;
      console.log('returned login FC data is: ', data);
      if (data.path) {
        window.location = data.path;
      } else {
        this.setState({ isLoading: false });
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  render() {
    const { isLoading } = this.state;
    console.log(isLoading);
    const { currentUser } = firebaseAuth();
    let isIdentityVerified = false;
    /* eslint-disable prefer-destructuring */
    if (currentUser) isIdentityVerified = currentUser.isIdentityVerified;

    if (!isIdentityVerified) {
      return (
        // <Alert className="mb-0" color="danger">
        //   <div className="title mb-10"><span className="lnr lnr-warning" /> Vérification d'identité</div>
        //   Pour des raisons de sécurité, nous devons vérifier l'authenticité de votre compte.
        //   <br />Aucune action de transmission ou de sécurisation de votre patrimoine ne pourra être enclenchée sans cette vérification.
        //   <br />Afin de vérifier votre compte, veuillez le lier à votre compte FranceConnect :
        //   <div className="mt-20 text-center">
        //     {
        //       isLoading ? (
        //         <Spinner
        //           role="status"
        //           aria-hidden="true"
        //         />
        //       ) : (
        //         <Button style={{ padding: 0, border: 0 }} className="btn-link mr-0" onClick={this.loginFC}>
        //           <img style={{ width: 186 }} src={`${process.env.PUBLIC_URL}/img/FCbouton.svg`} alt="FC_img" />
        //         </Button>
        //       )
        //     }
        //     <div className="mt-8">
        //       <a className="fc-link" href="https://franceconnect.gouv.fr/" target="_blank" rel="noopener noreferrer">
        //         Qu’est-ce que FranceConnect ?
        //       </a>
        //     </div>
        //   </div>
        // </Alert>
        <div className="deleteInfo pb-20 mb-20 fs12">
          <div className="mainContainer">
            <InformationOutlineIcon />
            <h3 className="fw-500 mb-10">
              Vérification d'identité
            </h3>
            <div className="text-left">
              <p className="fw-500">Pour des raisons de sécurité, nous devons vérifier l'authenticité de votre compte.</p>
              <p className="fw-500">Aucune action de transmission ou de sécurisation de votre patrimoine ne pourra être enclenchée sans cette vérification.</p>
              {/* <p className="fw-500">Deux méthodes vous sont proposées, selon vos préférences :</p> */}
              <p className="fw-500">Afin de vérifier votre compte, veuillez le lier à votre compte FranceConnect :</p>
            </div>
          </div>
          <Row noGutters className="mt-0">
            <Col className="text-center">
              {/* style={{ borderRight: '1px solid' }}  */}
              {
                isLoading ? (
                  <Spinner
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <Button style={{ padding: 0, border: 0 }} className="btn-link mr-0" onClick={this.loginFC}>
                    <img style={{ width: 186 }} src={`${process.env.PUBLIC_URL}/img/FCbouton.svg`} alt="FC_img" />
                  </Button>
                )
              }
              <div className="mt-8">
                <a className="fc-link" href="https://franceconnect.gouv.fr/" target="_blank" rel="noopener noreferrer">
                  Qu’est-ce que FranceConnect ?
                </a>
              </div>
              {/* <p className="fs10 lh12 pl-20 pr-20">
                *Connexion possible via Impots.gouv, digiposte, Assurance maladie, etc
                <br /><b>Durée : 1 minute</b>
              </p> */}
            </Col>
            {/* <Col className="text-center">
              <Button disabled className="text-left lh16 mb-10" style={{ paddingLeft: 80, color: 'rgb(112, 187, 253)' }} color="white" onClick={goKyc}>
                <img style={{ width: 30, position: 'absolute', left: 25 }} src={`${process.env.PUBLIC_URL}/img/identity.png`} alt="KYC_img" />
                Processus de <br />vérification
              </Button>
              <p className="fs10 lh12 pl-20 pr-20">
                *Envoi de pièces d'identités, puis vérification en direct via votre caméra
                <br /><b>Bientôt disponible</b>
              </p>
            </Col> */}
          </Row>
        </div>
      );
    }
    return null;
  }
}

export default IdentityCheck;
